import { CredentialProvider, User, PartnerOrganization } from '../types';
import { ssoUserPartners } from '../constants';

export const isSSOUser = (user: User, organizationName: string): boolean => {
  return (
    user.credentials.provider.type !== CredentialProvider.OKTA ||
    Object.values(ssoUserPartners).includes(organizationName.toLocaleLowerCase() as PartnerOrganization)
  );
};
